import { render, staticRenderFns } from "./shifts.vue?vue&type=template&id=247422c6"
import script from "./shifts.vue?vue&type=script&lang=js"
export * from "./shifts.vue?vue&type=script&lang=js"
import style0 from "./shifts.vue?vue&type=style&index=0&id=247422c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports